import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import NotLoggedIn from "../views/NotLoggedIn.vue";
import LoggedIn from "../views/LoggedIn.vue";
import OAuthSimplyhealth from "../pages/oauth/simplyhealth/Authenticate";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TCs from "../pages/TCs";
import StripeMobileRedirect from "@/pages/StripeMobileRedirect.vue";
import AccessPage from "@/pages/oauth/simplyhealth/AccessPage.vue";
import NotFound from "../pages/NotFound.vue";
import SpectrumFAQs from "../pages/SpectrumFAQs.vue";
import CancellationPolicy from "../pages/CancellationPolicy.vue";


Vue.use(VueRouter);

const isConnectedMentalHealth = false;
function getHomePageComponent() {
  return isConnectedMentalHealth ? LoggedIn : LoggedIn;
}
const beforeEnterHandler = function (to, from, next) {

  next();
}
const routes = [
  {
    path: "/login",
    name: "NotLoggedIn",
    component: NotLoggedIn,
  },
  {
    path: "/oauth/simplyhealth/authenticate",
    name: "OAuthSimplyhealth",
    component: OAuthSimplyhealth
  },
  {
    path: "/access",
    name: "AccessPage",
    component: AccessPage,
    props: route => ({ token: route.query.token }),
  },
  {
    path: "/",
    name: "myHealth",
    component: LoggedIn,
  },
  {
    path: "/session-booking",
    name: "dmhStart",
    component: LoggedIn,
  },
  {
    path: "/transaction-success",
    name: "paymentConfirmation",
    component: LoggedIn,
  },
  {
    path: "/transaction-cancelled",
    name: "dmhTransactionCancelled",
    component: LoggedIn,
  },
  {
    path: '/my-health-area/:areaId',
    name: 'myHealthArea',
    component: LoggedIn,
    props: true,
  },
  {
    path: '/my-health-handover/:areaId/:serviceId',
    name: 'myHealthHandover',
    component: LoggedIn,
    props: true,
  },
  {
    path: "/coaching-platform",
    name: "coachingPlatform",
    component: LoggedIn,
  },
  {
    path: "/f2f/:sessionId/:notificationId",
    name: "dmhF2F",
    component: LoggedIn,
  },
  {
    path: "/message/:sessionId/:type",
    name: "dmhMessage",
    component: LoggedIn,
  },
  {
    path: "/booking-video-room/:booking_id/:tests?",
    name: "bookingVideoRoom",
    component: LoggedIn
  },
  // {
  //   path: "/finance",
  //   name: "dmhFinance",
  //   component: LoggedIn,
  // },
  {
    path: "/learn-more",
    name: "dmhFaqs",
    component: LoggedIn
  },
  {
    path: "/faqs",
    name: "SpectrumFAQs",
    component: SpectrumFAQs,
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: PrivacyPolicy
  },
  {
    path: "/cancellation-policy",
    name: "CancellationPolicy",
    component: CancellationPolicy
  },
  {
    path: "/terms-and-conditions/:type?",
    name: "TCs",
    component: TCs
  },
  // {
  //   path: "/articles",
  //   name: "dmhArticles",
  //   component: LoggedIn,
  // }
  {
    path: "/mobile-redirect",
    name: "mobileRedirect",
    component: StripeMobileRedirect
  },
  {
    path: "/mobile-transaction-cancelled",
    name: "mobileTransactionCancelled",
    component: StripeMobileRedirect
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound
  }
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

if (store.getters.hardcoded && store.getters.hardcoded.permittedRoutes) {
  router.beforeEach((to, from, next) => {
    if (
      !store.getters.hardcoded.permittedRoutes.includes(to.name)
    ) {
      try {
        next(store.getters.homeRoute);
      } catch (e) {
        console.log(e)
        next('/login')
      }
    }
    next();
  });
}
export default router;
